import React, {useState} from "react";
import {XMarkIcon} from "@heroicons/react/24/solid";

export default function Modal({
                                  showButtonLabel,
                                  title,
                                  content,
                                  confirmButtonLabel,
                                  handleConfirm,
                                  showIcon,
                                  buttonClasses = 'button-outline-small'
                              }) {
    const [showModal, setShowModal] = useState(false);

    const handleConfirmAction = () => {
        handleConfirm();
        setShowModal(false);
    }

    return (
        <>
            {!showIcon &&
                <button
                    className={`${buttonClasses}`}
                    onClick={() => setShowModal(true)}>
                    {showButtonLabel}
                </button>
            }
            {showIcon &&
                <button
                    className={`${buttonClasses}`}
                    onClick={() => setShowModal(true)}>
                    <div className="">
                        <XMarkIcon className="h-6 w-6"/>
                    </div>
                </button>
            }
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {title}
                                    </h3>
                                    <button
                                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                        onClick={() => setShowModal(false)}>
                                            <span
                                                className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                              ×</span>
                                    </button>
                                </div>
                                {/*body*/}
                                <div className="relative p-4 flex-auto">
                                    <div className="leading-relaxed">
                                        {content?.map((contentItem, index) => (
                                            <div key={index}
                                                 className={`${contentItem?.classes} py-2`}>{contentItem?.text}</div>
                                        ))}
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        {confirmButtonLabel}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}
